import { ReactComponent as DiskoIcon } from 'img/icons/disko.svg';
import { ReactComponent as ComboNewIcon } from 'img/icons/vk_combo.svg';
import React from 'react';
import { IFeatureData } from 'reactApp/constants/products/features';
import { openDisko } from 'reactApp/constants/products/features.constants';

const baseQuotaFeatures: IFeatureData[] = [
    {
        text: 'Без рекламы в Почте и Облаке',
        textJsx: (
            <>
                <a
                    target="_blank"
                    href="https://cloud.mail.ru/promo/quota?utm_source=subscriptions&utm_medium=organic&utm_campaign=single_quota"
                    rel="noreferrer"
                >
                    Без рекламы
                </a>
                {'\u00A0'}в Почте и Облаке
            </>
        ),
        key: 'ad',
    },
    {
        text: 'Загрузка файлов до\u00A0100\u00A0ГБ в Облако',
        key: 'upload',
    },
    {
        text: 'Отправка файлов до\u00A0100\u00A0ГБ в письмах',
        key: 'sending',
    },
    {
        text: 'Автоудаление папок',
        key: 'autodelete',
    },
    {
        text: 'Приоритетная поддержка',
        key: 'support',
    },
];
const baseQuotaProFeatures: IFeatureData[] = [
    {
        text: 'Лицензия Диск-О: на год в подарок',
        key: 'disko',
        icon: <DiskoIcon width={16} height={16} />,
        onClick: openDisko,
        delimiters: true,
    },
    {
        text: 'бесплатно на 3\u00A0месяца',
        key: 'combo',
        icon: <ComboNewIcon width={69} height={16} />,
        delimiters: true,
    },
];

const baseQuotaProFeatures_6m = [
    {
        ...baseQuotaProFeatures[0],
        text: 'Лицензия ДискО: на 6\u00A0месяцев в подарок',
    },
    {
        ...baseQuotaProFeatures[1],
        text: 'бесплатно на 1\u00A0месяц',
    },
];

export const quotaFeatures: Record<string, IFeatureData[]> = {
    quotaTariffsLanding: baseQuotaFeatures,
    quotaRegular: baseQuotaFeatures,
    quotaProfessional: [...baseQuotaFeatures, ...baseQuotaProFeatures],
    quotaProfessional_6m: [...baseQuotaFeatures, ...baseQuotaProFeatures_6m],
};
